import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const { store } = require('../../../lib/bputils').default;

const getLink = (link) => {
  const overriddenLink = store.get(link);
  if (overriddenLink) {
    return overriddenLink;
  }
  return link;
};

const SecondaryNavItem = ({ parentMenuId, name, link, active }) => (
  <a
    href={getLink(link)}
    className={`${styles.navItem} ${active ? styles.active : ''}  ${(parentMenuId === 'emergency' ? styles.emergencyFeatures : '')} `}
  >
    <div>
      {name}
    </div>
  </a>
);

SecondaryNavItem.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  parentMenuId: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

SecondaryNavItem.defaultProps = {
  active: false,
};

export default SecondaryNavItem;
